import * as React from 'react';

import { Helmet } from 'react-helmet-async';

import { ProductsEditForm, ProductsEditHeader } from './components';

export default function ProductsEdit() {
  return (
    <React.Fragment>
      <Helmet>
        <title>ویرایش محصول‌ها | کاشی لند</title>
      </Helmet>
      <ProductsEditHeader />
      <ProductsEditForm />
    </React.Fragment>
  );
}
